import { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";

import { ToastContainer } from "react-toastify";

import Spinner from "./Utils/Spinner";
import ScrollToTopButton from "./Components/Buttons/ScrollToTopBtn";


const LazyApp = lazy(() => import("./App"));

const container = document.getElementById("main");
if (!container) throw new Error("Root element #main not found");

const root = ReactDOM.createRoot(container);

root.render(
  <>
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      theme="colored"
      pauseOnFocusLoss
    />

    <Suspense fallback={<Spinner />}>
      <LazyApp />
    </Suspense>

    <ScrollToTopButton threshold={250} />
  </>
);
